import { render, staticRenderFns } from "./PolicyTab.html?vue&type=template&id=7320b70d&external"
import script from "./PolicyTab.js?vue&type=script&lang=js&external"
export * from "./PolicyTab.js?vue&type=script&lang=js&external"
import style0 from "./PolicyTab.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports